import React, { useState, useEffect } from 'react';

import ImageModelOne from '~/assets/images/Login/Models/1.png';
import ImageModelTwo from '~/assets/images/Login/Models/2.png';
import ImageModelThree from '~/assets/images/Login/Models/3.png';
import ImageModelFour from '~/assets/images/Login/Models/4.png';
import ImageModelFive from '~/assets/images/Login/Models/5.png';
import ImageModelSix from '~/assets/images/Login/Models/6.png';
import ImageModelSeven from '~/assets/images/Login/Models/7.png';

export const imagesList = [
  ImageModelOne,
  ImageModelTwo,
  ImageModelThree,
  ImageModelFour,
  ImageModelFive,
  ImageModelSix,
  ImageModelSeven,
]

export default function SliderImages() {
  const [currentIndexImage, setCurrentIndexImage] = useState(0);
  const [styleImage1, setStyleImage1] = useState({transition: 'opacity 0s', opacity: '1'});
  const [styleImage2, setStyleImage2] = useState({transition: 'opacity 0s', opacity: '0'});
  const [styleImage3, setStyleImage3] = useState({transition: 'opacity 0s', opacity: '0'});
  const [styleImage4, setStyleImage4] = useState({transition: 'opacity 0s', opacity: '0'});
  const [styleImage5, setStyleImage5] = useState({transition: 'opacity 0s', opacity: '0'});
  const [styleImage6, setStyleImage6] = useState({transition: 'opacity 0s', opacity: '0'});
  const [styleImage7, setStyleImage7] = useState({transition: 'opacity 0s', opacity: '0'});

  const setStylesIndexes = [
    setStyleImage1,
    setStyleImage2,
    setStyleImage3,
    setStyleImage4,
    setStyleImage5,
    setStyleImage6,
    setStyleImage7,
  ]

  useEffect(() => {
    const timerInterval = setInterval(() => {
      const lastIndex = imagesList.length - 1;
      const index = (currentIndexImage + 1) % (lastIndex + 1);
      const beforeImage = index -1;
      setCurrentIndexImage(index);
      setStylesIndexes[beforeImage < 0 ? 6 : beforeImage]({transition: 'opacity 2s', opacity: '0'});
      setStylesIndexes[index]({transition: 'opacity 1s', opacity: '1'});
    }, 3000 );
    return () => clearInterval(timerInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndexImage]);

  return (
    <>
      <img style={styleImage1} src={imagesList[0]} alt='Model Ultragaz'/>
      <img style={styleImage2} src={imagesList[1]} alt='Model Ultragaz'/>
      <img style={styleImage3} src={imagesList[2]} alt='Model Ultragaz'/>
      <img style={styleImage4} src={imagesList[3]} alt='Model Ultragaz'/>
      <img style={styleImage5} src={imagesList[4]} alt='Model Ultragaz'/>
      <img style={styleImage6} src={imagesList[5]} alt='Model Ultragaz'/>
      <img style={styleImage7} src={imagesList[6]} alt='Model Ultragaz'/>
    </>
  )
}
